/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Totp_Algorithm_Sha1_HintInputs */



/**
* | output |
* | --- |
* | "Required for Microsoft Authenticator. Less secure - use only if your app does not accept SHA-256 codes." |
*
* @param {Profile_Security_Totp_Algorithm_Sha1_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_totp_algorithm_sha1_hint = /** @type {((inputs?: Profile_Security_Totp_Algorithm_Sha1_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Totp_Algorithm_Sha1_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erforderlich für Microsoft Authenticator. Weniger sicher - nur verwenden, wenn deine App keine SHA-256-Codes akzeptiert.")
	return /** @type {LocalizedString} */ ("Required for Microsoft Authenticator. Less secure - use only if your app does not accept SHA-256 codes.")
});